export default {
      id: "icon-calculator-usage",
      viewBox: "0 0 80 110",
      url: __webpack_public_path__ + "icons.svg#icon-calculator",
      toString: function () {
        return this.url;
      }
    }